<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/sjwh">盛京文化</router-link> >
      <router-link to="/sjwh/zhoukan">盛京医讯</router-link>
    </div>

    <div class="container-width yixun mt50">
      <div class="l-img">
        <div class="block z-fm">
          <img :src="currentColumn.img" />
          <p>
            {{ currentContent.num }}:
            <span v-for="(item, index) in currentList" :key="index">{{
              item.title
            }}</span>
          </p>
        </div>
        <div class="block headline" style="margin-top: 30px">
          <p class="title">标题导航</p>
          <ul v-for="(item, index) in currentList" :key="index">
            <li>
              <img
                src="../../assets/image/checkbox.gif"
                width="10"
                height="10"
                v-if="item.id == currentContent.id"
              />
              <span @click="goArticle(item)">{{ item.title }}</span>
            </li>
          </ul>
        </div>
        <div class="block download">
          <p>离线下载电子报<i class="iconfont icon-xiazai"></i></p>
        </div>
      </div>
      <div class="r-list">
        <ul>
          <li class="li-item" style="background-color: #00479d; color: #fff">
            <span @click="goPrePeriod()">上一期</span
            ><span @click="goNextPeriod()">下一期</span>
          </li>
          <li>
            <div class="title">
              {{ currentContent.title }}
            </div>
          </li>
          <li>
            <ul class="post-meta">
              <li @click="changeFontSize('plus')">
                <i class="iconfont icon-fangda"></i>放大
              </li>
              <li @click="changeFontSize('minus')">
                <i class="iconfont icon-suoxiao" style="font-size: 1.1rem"></i
                >缩小
              </li>
              <li @click="changeFontSize('cancle')">
                <i class="iconfont icon-morendaxiao"></i>默认
              </li>
              <!-- <li @click="playVoice">
                <i class="iconfont icon-yuyin" style="font-size: 1.2rem"></i
                >朗读
              </li> -->
            </ul>
          </li>

          <li>
            <div
              class="content"
              v-html="currentContent.description"
              :style="{ fontSize: `${fontSize}rem` }"
            ></div>
          </li>

          <li class="cycle">
            <span @click="prevArticle">上一篇</span
            ><span @click="nextArticle">下一篇</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import service from "../../service/sjwh";
import BANNER from "../../components/banner/sjwh";
import config from "../../config/dev";
// const synth = window.speechSynthesis;
// const msg = new SpeechSynthesisUtterance();
export default {
  name: "ZHOUKANARTICLE",
  data() {
    return {
      navigationData: [
      {
          name: "百年历史",
          path: "/sjwh",
          width: "50%",
        },
        {
          name: "院标/办院理念/院训/院歌",
          path: "/sjwh/yuange",
          width: "50%",
        },
        {
          name: "盛京医讯",
          path: "/sjwh/zhoukan",
          width: "33%",
        },
        {
          name: "盛京TV",
          path: "/sjwh/tv",
        },
        {
          name: "盛京映像",
          path: "/sjwh/yingxiang",
        },
        // {
        //   name: "盛京医院的故事",
        //   path: "/sjwh/gushi",
        // },
      ],
        
      currentPath: "/sjwh/zhoukan",
      list: [],
      currentList: [],
      currentContent: {},
      beforeContent: {},
      afterContent: {},
      currentColumn: {}, // 当前期刊
      beforeColumn: {}, // 上一期刊
      afterColumn: {}, // 下一期刊
      pageIndex: 1,
      pageSize: 8,
      picUrl: "",
      image04: require("../../assets/image/image04.jpg"),
      image03: require("../../assets/image/image03.jpg"),
      image01: require("../../assets/image/image01.jpg"),
      image02: require("../../assets/image/image02.jpg"),
      image06: require("../../assets/image/image06.jpg"),
      nowDate: "", // 当前日期
      nowTime: "", // 当前时间
      nowWeek: "", // 当前星期
      leftList: [],
      Data: {},
      // 日历
      date: {
        year: "",
        month: "",
        date: "",
      },
      current: {
        year: "",
        month: "",
        date: "",
      },
      week: ["日", "一", "二", "三", "四", "五", "六"],
      days: [],
      fontSize: 1.2,
    };
  },
  components: { BANNER },
  computed: {},
  created() {
    this.Data = { ...this.$route.query };
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let parmes = {
        isshow: "1",
        medicalinfoId: this.Data.medicalinfoId,
        num: this.Data.num,
        id: this.Data.id,
      };
      service.getwzSjMedicalInformationInfo(parmes, (res) => {
        // res.current.releaseDate = res.current.releaseDate
        //   ? res.current.releaseDate.split(" ")[0]
        //   : "";
        this.currentList = res.current;
        this.currentContent = res.current.find((item) => {
          return item.id == this.Data.id;
        });
        this.beforeContent = res.before ? { ...res.before } : "";
        this.afterContent = res.after ? { ...res.after } : "";
        this.handlePrevNext(this.currentContent.medicalinfoId);
      });
    },
    // 处理封面
    handlePrevNext(id) {
      service.getInfo(
        {
          id: id,
        },
        (res) => {
          if (res.current) {
            res.current.img =
              config.url +
              "/file/downloadFile/" +
              res.current.img +
              "?isDownload=true";
          }
          this.beforeColumn = res.before ? { ...res.before } : "";
          this.currentColumn = { ...res.current };
          this.afterColumn = res.after ? { ...res.after } : "";

          this.$forceUpdate();
        }
      );

      // 左侧 list
      let listParmes = {
        medicalinfoId: id,
        pageIndex: 1,
        pageSize: 200,
        isshow: "1",
      };
      service.getwzSjMedicalInformationMenuList(listParmes, (res) => {
        if (res.content.length) {
          // res.content.map((item) => {
          //   item.releaseDate = item.releaseDate
          //   item.img =
          //     config.url +
          //     "/file/downloadFile/" +
          //     item.img +
          //     "?isDownload=true";
          // });
          this.leftList = res.content || [];
        }
      });
    },
    goPrePeriod() {
      if (this.beforeColumn) {
        if (e.url.length) {
          window.open(e.url, "_blank");
        } else {
          const { href } = this.$router.resolve({
            path: `/sjwh/zhoukan/list`,
            query: {
              id: this.beforeColumn.id,
            },
          });
          window.open(href, "_self");
        }
      } else {
        this.$message({
          message: "暂无数据",
          type: "warning",
        });
      }
    },
    goNextPeriod() {
      if (this.afterColumn) {
        const { href } = this.$router.resolve({
          path: `/sjwh/zhoukan/list`,
          query: {
            id: this.afterColumn.id,
          },
        });
        window.open(href, "_self");
      } else {
        this.$message({
          message: "暂无数据",
          type: "warning",
        });
      }
    },
    dealWithTime(data) {
      // 获取当前时间
      let formatDateTime;
      let Y = data.getFullYear();
      let M = data.getMonth() + 1;
      let D = data.getDate();
      let H = data.getHours();
      let Min = data.getMinutes();
      let S = data.getSeconds();
      let W = data.getDay();
      H = H < 10 ? "0" + H : H;
      Min = Min < 10 ? "0" + Min : Min;
      S = S < 10 ? "0" + S : S;
      switch (W) {
        case 0:
          W = "日";
          break;
        case 1:
          W = "一";
          break;
        case 2:
          W = "二";
          break;
        case 3:
          W = "三";
          break;
        case 4:
          W = "四";
          break;
        case 5:
          W = "五";
          break;
        case 6:
          W = "六";
          break;
        default:
          break;
      }
      this.nowDate = Y + "年" + M + "月" + D + "日 ";
      this.nowWeek = "星期" + W;
      this.nowTime = H + ":" + Min + ":" + S;
      // formatDateTime = Y + "年" + M + "月" + D + "日 " + " 周" +W + H + ":" + Min + ":" + S;
    },
    goArticle(e) {
      let articleId = e.id;
      if (e.url && e.url.length) {
        window.open(e.url, "_blank");
      } else {
        const { href } = this.$router.resolve({
          path: `/sjwh/zhoukan/article`,
          query: {
            id: `${articleId}`,
            medicalinfoId: e.medicalinfoId,
            num: e.num,
          },
        });
        window.open(href, "_self");
      }
    },
    // 上一篇
    prevArticle() {
      if (this.beforeContent) {
        let id = this.beforeContent.id; //改变参数
        const { href } = this.$router.resolve({
          path: "/sjwh/zhoukan/article/",
          query: {
            id: id,
            medicalinfoId: this.beforeContent.medicalinfoId,
            num: this.beforeContent.num,
          },
        });
        window.open(href, "_self");
        this.init(id);
      } else {
        this.$message({
          message: "暂无数据",
          type: "warning",
        });
      }
    },
    // 下一篇
    nextArticle() {
      if (this.afterContent) {
        let id = this.afterContent.id; //改变参数
        const { href } = this.$router.resolve({
          path: "/sjwh/zhoukan/article/",
          query: {
            id: id,
            medicalinfoId: this.afterContent.medicalinfoId,
            num: this.afterContent.num,
          },
        });
        window.open(href, "_self");
        this.init(id);
      } else {
        this.$message({
          message: "暂无数据",
          type: "warning",
        });
      }
    },
    zhouKanIndex() {
      const { href } = this.$router.resolve({
        path: `/sjwh/zhoukan/list`,
        query: {
          id: this.currentContent.medicalinfoId,
        },
      });
      window.open(href, "_self");
    },
    changeFontSize(e) {
      if (e == "plus") {
        this.fontSize += 0.1;
      } else if (e == "minus") {
        this.fontSize -= 0.1;
      } else {
        this.fontSize = 1.2;
      }
    },
    playVoice() {
      this.handleSpeak(this.currentContent.description); // 传入需要播放的文字
    },
    // 语音播报的函数
    handleSpeak(text) {
      msg.text = text; // 文字内容: 小朋友，你是否有很多问号
      msg.lang = "zh-CN"; // 使用的语言:中文
      msg.volume = 1; // 声音音量：1
      msg.rate = 1; // 语速：1
      msg.pitch = 1; // 音高：1
      synth.speak(msg); // 播放
    },
    // 语音停止
    handleStop(e) {
      msg.text = e;
      msg.lang = "zh-CN";
      synth.cancel(msg);
    },
  },
  mounted() {
    this.dealWithTime(new Date());
  },
  watch: {},
};
</script>


<style scoped lang="scss">
a {
  color: #000;
}

.STYLE30 {
  color: #001e50;
  font-weight: bold;
}

.commonlight2 {
  background-color: #a2dbff;
}

.commoncolor3 {
  background-color: #ffffff;
}
.container {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;

  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #ffffff;
  width: 100%;
}
// 日历

.calendar-card {
  position: absolute;
  /* width: 290px; */
  height: 220px;
  padding: 5px 5px 0px 5px;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  background-color: #fff;
}

.calendar-card:hover {
  box-shadow: 0px 0px 5px 5px #cfcfcf;
}

.calendar-bar {
  height: 40px;
  color: #727272;
  line-height: 40px;
  text-align: center;
  /* background-color: #ebeef5; */
}

.calendar-date {
  display: inline-block;
  width: 100px;
}

.button {
  width: 20px;
  height: 20px;
  background-color: #fff;
  color: #aaa;
  border: 0;
  border-radius: 5px;
}

.button:hover {
  background-color: #eee;
  cursor: pointer;
}

.ul-week {
  display: grid;
  width: 245px;
  grid-template-rows: 20px;
  grid-template-columns: repeat(7, 35px); /**/
  list-style: none;
  text-align: center;
  font-size: 13px;
  color: #aaa;
  margin: 5px 20px 5px 20px;
  padding-inline-start: 0px;
  padding-inline-end: 0px;
  border-bottom: 1px solid #eee;
}

.li-week {
  display: inline-block;
}

.ul-day {
  display: grid;
  width: 245px;
  grid-template-rows: repeat(6, 22px);
  grid-template-columns: repeat(7, 35px);
  list-style: none;
  text-align: center;
  margin: 5px 20px 5px 20px;
  padding-inline-start: 0px;
  padding-inline-end: 0px;
}

.li-day {
  display: inline-block;
  font-size: 10px;
  line-height: 22px;
  text-align: center;
  border-radius: 5px;
  margin: 1px;
  color: rgb(91, 91, 91);
}

.li-day:hover {
  background-color: #717de2;
  color: #fff;
  font-size: 15px;
  cursor: pointer;
}

.li-day[isThisMonth="1"] {
  color: rgb(190, 190, 190);
  font-size: 10px;
}

.li-day[isThisMonth="1"]:hover {
  background-color: #717de2;
  color: #fff;
  font-size: 15px;
  cursor: pointer;
}

.li-day[isThisMonth="3"] {
  border-radius: 5px;
  color: rgb(255, 255, 255);
  background-color: #79bbff;
  font-weight: 600;
}
.cycle {
  height: 80px;
  line-height: 80px;
  padding: 0 30px;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-top: 1px solid #ebebeb;
  span {
    font-size: 1.3rem;
    cursor: pointer;
  }
}
.yixun {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;

  margin-bottom: 50px;
  .l-img {
    width: 280px;
    p {
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 1.2rem;
    }
  }
  .r-list {
    width: calc(100% - 310px);
    ul {
      border: 1px solid #ebebeb;
      margin-bottom: 50px;
      .li-item {
        cursor: pointer;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #ebebeb;
        padding: 0 30px;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        -ms-flex-pack: justify;
        justify-content: space-between;
      }
      li-item:last-child {
        border-bottom: none;
      }
      li {
        .title {
          padding-top: 30px;
          padding-bottom: 30px;
          font-weight: bold;
          text-align: center;
          border-bottom: 1px solid #ebebeb;
          font-size: 1.8rem;
          color: #323232;
        }
        .content {
          font-size: 1.2rem;
          color: #323232;
          padding: 20px 35px;
          line-height: 40px;
          table {
            width: 90% !important;
          }
        }
      }
    }
  }
  .block {
    box-shadow: 0px 0px 59px 0px rgba(19, 40, 83, 0.1);
  }
  .z-fm {
    box-shadow: 0px 0px 59px 0px rgba(19, 40, 83, 0.3);
    position: relative;
    img {
      width: 280px;
      height: 396.8px;
    }
    p {
      position: absolute;
      width: 160px;
      height: 35px;
      line-height: 35px;
      left: 60px;
      bottom: 15px;
      border: 1px solid #fff;
      color: #fff;
    }
  }
  .headline {
    .title {
      background: #00479d;
      color: #fff;
      height: 40px;
      line-height: 40px;
    }
    ul {
      li {
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
        border-bottom: 1px solid #ebebeb;
      }
    }
  }
  .download {
    height: 120px;
    width: 100%;
    cursor: pointer;
    margin-top: 30px;
    p {
      display: block;
      width: 100%;
      height: 100%;
      background: #00479d;
      color: #fff;
      display: -webkit-flex;
      display: flex;
      -webkit-justify-content: center;
      justify-content: center;

      -webkit-box-align: center;
      align-items: center;
      font-size: 1.4rem;
      letter-spacing: 3px;
      i {
        font-size: 1.4rem;
        margin-right: 5px;
        margin-top: 3px;
        display: inline-block;
      }
    }
  }
  .pagination {
    margin-top: 30px;
    margin-bottom: 30px;
  }
}
.post-meta {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  height: 56px;
  -webkit-justify-content: center;
  justify-content: center;

  align-content: center;
  li {
    text-align: center;
    font-size: 1rem;
    font-weight: bold;
    height: 56px;
    line-height: 56px;
    border-right: 1px solid #ebebeb;
    color: #8d8d8d;
    font-weight: 500;
    padding-left: 20px;
    padding-right: 20px;
    cursor: pointer;
    i {
      display: inline-block;
      margin-right: 3px;
      font-size: 1rem;
    }
  }
  li:last-child {
    border-right: none;
  }
}
</style>
